/* eslint-disable max-lines */
/* eslint-disable complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import { call, put, takeLatest, select, all, takeLeading } from 'redux-saga/effects';
import logger from '@tcp/core/src/utils/loggerInstance';
import { setDefaultStore } from '@tcp/core/src/components/features/account/User/container/User.actions';
import { getFavoriteStore } from '@tcp/core/src/components/features/account/User/container/User.selectors';
import getBopisInventoryDetails from '@tcp/core/src/services/abstractors/common/bopisInventory/bopisInventory';
import {
  getFetchClosestStore,
  getSwitchToSfccForStoreInfo,
  getIsStoreInventoryApi,
  getBopisMultipleStoreEnabled,
  getModalBopisStoreCount,
  getBossMultipleStoreEnabled,
  getShowStoreSpecialsV2,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { getSetGeoDefaultStoreActn } from '@tcp/core/src/components/features/storeLocator/StoreLanding/container/StoreLanding.actions';
import {
  BOPIS_ITEM_AVAILABILITY,
  BOPIS_STORE_ERROR,
} from '@tcp/core/src/components/common/organisms/PickupStoreModal/PickUpStoreModal.constants';
import { trackClickWithData } from '@tcp/core/src/analytics/actions';
import { parseBoolean, getMultipackCount } from '@tcp/core/src/utils/utils';
import { setLoaderState } from '@tcp/core/src/components/common/molecules/Loader/container/Loader.actions';
import { getLocalStorage } from '../../../../../utils/localStorageManagement';
import names from '../../../../../constants/eventsName.constants';
import { PICKUP_MODAL_ACTIONS_CONSTANTS } from '../PickUpStoreModal.constants';
import { maxAllowedStoresInCart } from '../PickUpStoreModal.config';
import {
  setBopisStores,
  setStoreSearchError,
  setUserCartStores,
  setStoreSearchingState,
  setIsGetUserStoresLoaded,
  setPickupModalProduct,
  setBopisDefaultStores,
  setDistanceMiles,
  setNearestAvailableStoreActn,
  setNearestAvailableStoreLoadingActn,
  setDefaultSuggestedStores,
  setStoreIdList,
  setAllBopisStores,
  setRecommendationNearestAvailableStoreActn,
  setMultiPackDetails,
  setStoreSpecialList,
} from './PickUpStoreModal.actions';
import {
  submitGetBopisSearchByLatLng,
  getCartStoresPlusInventorygraph,
  getDefaultStoresPlusInventorybyLatLng,
  getStoresPlusInventorybyLatLnggraph,
} from '../../../../../services/abstractors/productListing/pickupStoreInventoryHelper';
import {
  getCurrentProduct,
  getIsBopisCtaEnabled,
  getIsBossCtaEnabled,
  getIsPickupModalOpenFromBagPage,
  getIsPDP,
  getIsBopisPickupSelected,
} from './PickUpStoreModal.selectors';
import {
  getPageName,
  getStoreSearchDistance,
  getStoreSearchCriteria,
} from '../molecules/PickupStoreSelectionForm/container/PickupStoreSelectionForm.selectors';
import { getUnbxdXappConfigs } from '../../../../features/browse/ProductListing/container/ProductListing.saga';
import {
  getABTestPdpService,
  getIsPdpServiceEnabled,
} from '../../../../../reduxStore/selectors/session.selectors';
import getProductInfoById from '../../../../../services/abstractors/productListing/productDetail';
import { fromAvailableStoresClick } from '../../ProductPickup/container/ProductPickup.actions';
import { PRODUCT_PICKUP_REDUCER_KEY } from '../../../../../constants/reducer.constants';
import {
  filterNearByStore,
  filterBossEligibleStores,
  filterDefaultStore,
  filterStoreIdList,
} from '../../ProductPickup/util';
import { getModalState } from '../../QuickViewModal/container/QuickViewModal.selectors';
import {
  fetchProductId,
  getMultipackProduct,
  storeBossBopisEligibility,
  getCurrentProductId,
} from './PickUpStoreModal.utils';

let scName = '';

function* trackSearchEvent(isSuccess, stores, isFromSearchCta) {
  const currentProduct = yield select(getCurrentProduct);
  const pageNameProp = yield select(getPageName);
  const storeSearchCriteria = yield select(getStoreSearchCriteria);
  const storeSearchDistance = yield select(getStoreSearchDistance);
  const favStore = yield select(getFavoriteStore);
  const isBopisCtaEnabled = yield select(getIsBopisCtaEnabled);
  const isBossCtaEnabled = yield select(getIsBossCtaEnabled);
  const isBossBopisEnabledinStores = storeBossBopisEligibility(
    stores,
    isBopisCtaEnabled,
    isBossCtaEnabled
  );
  const productId = getCurrentProductId(currentProduct);
  const customEvents = ['event105'];
  scName = names.screenNames.pickup_store_search105;

  if (isSuccess && stores.length && favStore && isBossBopisEnabledinStores) {
    customEvents.push('event106');
    scName = names.screenNames.pickup_store_search106;
  }

  let pageName = '';
  if (productId) {
    pageName = `${pageNameProp}:${productId}:${
      currentProduct && currentProduct.name && currentProduct.name.toLowerCase()
    }`;
  }

  const clickData = {
    customEvents,
    storeSearchCriteria,
    storeSearchDistance,
    pageName,
  };
  if (!isFromSearchCta) {
    yield put(
      trackClickWithData(clickData, {
        name: scName,
        module: 'browse',
      })
    );
  }
}

// eslint-disable-next-line sonarjs/cognitive-complexity
export function* getPickupStores(action) {
  const {
    payload,
    payload: {
      quantity,
      distance,
      country,
      variantId,
      isFromChangeStore,
      isFromSearchCta,
      isCart = false,
      nearestStoreUpdateFlag,
      isRecommendationsQV,
    },
  } = action;
  const state = yield select();
  const { currentSelectedPickUpTypeOnPDP } = payload;
  const fromAvailableStoreClick = nearestStoreUpdateFlag;
  const isBopisMultipleStoreEnabled = yield select(getBopisMultipleStoreEnabled);
  // Reset the bopis store data
  yield put(setBopisDefaultStores({ stores: [] }));
  if (Object.fromEntries(state[PRODUCT_PICKUP_REDUCER_KEY])?.fromAvailableStoreClick) {
    yield put(fromAvailableStoresClick(nearestStoreUpdateFlag));
  }
  yield put(setBopisStores({ stores: [] }));
  if (fromAvailableStoreClick) {
    yield put(setNearestAvailableStoreLoadingActn(true));
    yield put(setNearestAvailableStoreActn([]));
  }

  // Reset error  message
  yield put(setStoreSearchError(''));
  try {
    const storeSearchCriteria = yield select(getStoreSearchCriteria);
    yield put(setStoreSearchingState(true));
    const locationRes = yield call(submitGetBopisSearchByLatLng, payload);
    const { errorMessage, location } = locationRes;
    if (errorMessage) {
      yield put(setStoreSearchError(errorMessage));
      yield put(setNearestAvailableStoreLoadingActn(false));
      yield put(fromAvailableStoresClick(false));
    } else {
      const reqObj = {
        quantity,
        distance,
        lat: location.lat,
        lng: location.lng,
        country,
        variantId,
        isCart,
      };

      const storesResponse =
        reqObj.lat && reqObj.lng && reqObj.variantId
          ? yield call(getStoresPlusInventorybyLatLnggraph, {
              ...reqObj,
              storeSearchCriteria,
            })
          : {
              error: BOPIS_STORE_ERROR,
            };

      const { error, stores } = storesResponse;
      const storecount = yield select(getModalBopisStoreCount);
      const isBossMultipleStoreEnabled = yield select(getBossMultipleStoreEnabled);
      const fromBagPage = yield select(getIsPickupModalOpenFromBagPage);
      const userDefaultFavStore = JSON.parse(getLocalStorage('defaultStore'));
      const isBopisPickupSelected = yield select(getIsBopisPickupSelected);
      const isBopis =
        ((userDefaultFavStore && Object.keys(userDefaultFavStore)?.length === 0) ||
          userDefaultFavStore === undefined ||
          userDefaultFavStore === null) &&
        isBopisPickupSelected;

      const bopisCheck =
        isBopisMultipleStoreEnabled &&
        (currentSelectedPickUpTypeOnPDP === 'bopis' ||
          payload.currentSelectedPickUpTypeOnPdp === 'bopis' ||
          isBopis) &&
        !fromBagPage;

      const bossCheck =
        isBossMultipleStoreEnabled &&
        (currentSelectedPickUpTypeOnPDP === 'boss' ||
          payload.currentSelectedPickUpTypeOnPdp === 'boss' ||
          !isBopis) &&
        !fromBagPage;

      const bopisCheckAllPages =
        isBopisMultipleStoreEnabled &&
        (currentSelectedPickUpTypeOnPDP === 'bopis' ||
          payload.currentSelectedPickUpTypeOnPdp === 'bopis' ||
          isBopis);
      const storeSpecialV2Enabled = yield select(getShowStoreSpecialsV2);
      if (error) {
        yield put(setStoreSearchError(error));
        yield call(trackSearchEvent, false);
        yield put(setNearestAvailableStoreLoadingActn(false));
      } else {
        if (fromAvailableStoreClick || bossCheck) {
          yield put(setDefaultSuggestedStores(filterDefaultStore(stores, userDefaultFavStore)));
        }
        if (bopisCheckAllPages && storeSpecialV2Enabled) {
          const storeSpecialList = {};
          stores?.forEach((store) => {
            if (store?.productAvailability?.isStoreSpecial && store?.basicInfo?.storeDiscount)
              storeSpecialList[store?.basicInfo?.id] = store?.basicInfo?.storeDiscount;
          });
          yield put(setStoreSpecialList(storeSpecialList));
        }
        if (bopisCheck) {
          yield put(setAllBopisStores(stores));
          yield put(setStoreIdList(filterStoreIdList(stores)));
          if (isRecommendationsQV) {
            yield put(
              setRecommendationNearestAvailableStoreActn(filterNearByStore(stores, storecount))
            );
          } else {
            yield put(setBopisStores({ stores: filterNearByStore(stores, storecount) }));
          }
          if (fromAvailableStoreClick) {
            yield put(setNearestAvailableStoreActn(filterNearByStore(stores, storecount)));
          }
        } else if (bossCheck) {
          yield put(setBopisStores({ stores: filterBossEligibleStores(stores) }));
          if (fromAvailableStoreClick) {
            yield put(setNearestAvailableStoreActn(filterBossEligibleStores(stores)));
          }
        } else {
          yield put(setBopisStores({ stores }));
        }
        yield put(setNearestAvailableStoreLoadingActn(false));
        if (!nearestStoreUpdateFlag) {
          yield call(trackSearchEvent, true, stores, isFromSearchCta);
        }
      }
    }
    yield put(setStoreSearchingState(false));
    if (isFromChangeStore || isBopisMultipleStoreEnabled) {
      yield put(setLoaderState(false));
    }
  } catch (err) {
    yield put(setLoaderState(false));
    logger.error({
      error: err,
      extraData: {
        component: 'PickUpStoreModalSaga - getPickupStores',
        payloadRecieved: payload,
      },
    });
    yield put(setStoreSearchingState(false));
  }
}
export function* getDefaultStores(action) {
  const { payload } = action;
  const { defaultStore, distance, isModalOpeningFromAvailabilityFilter } = payload;
  // Reset error message
  yield put(setStoreSearchError(''));
  yield put(setBopisDefaultStores({ stores: [] }));
  try {
    yield put(setStoreSearchingState(true));
    const locationRes = yield call(submitGetBopisSearchByLatLng, payload);
    const { errorMessage, location } = locationRes;
    if (errorMessage) {
      yield put(setStoreSearchError(errorMessage));
    } else {
      const FETCH_CLOSEST_STORE = yield select(getFetchClosestStore);
      const SWITCH_TO_SFCC_FOR_STORE_INFO = yield select(getSwitchToSfccForStoreInfo);
      const storeLocatorSwitches = {
        FETCH_CLOSEST_STORE,
        SWITCH_TO_SFCC_FOR_STORE_INFO,
      };
      const reqObj = {
        lat: location.lat,
        lng: location.lng,
        defaultStore,
        distance,
        isModalOpeningFromAvailabilityFilter,
        storeLocatorSwitches,
      };

      const storesResponse = yield call(getDefaultStoresPlusInventorybyLatLng, reqObj);

      const { error, stores } = storesResponse;
      if (error) {
        yield put(setStoreSearchError(error));
      } else {
        yield put(setDistanceMiles({ distance: distance || 25 }));
        yield put(setBopisDefaultStores({ stores }));
      }
    }
    yield put(setStoreSearchingState(false));
  } catch (err) {
    yield put(setLoaderState(false));
    logger.error({
      error: err,
      extraData: {
        component: 'PickUpStoreModalSaga - getPickupStores',
        payloadRecieved: payload,
      },
    });
    yield put(setStoreSearchingState(false));
  }
}
function getItemBopisAvailability(inventory, quantity) {
  if (inventory.quantity < quantity || inventory.status === 'Out of Stock') {
    return BOPIS_ITEM_AVAILABILITY.UNAVAILABLE;
  }
  if (inventory.status === 'In Stock') {
    return BOPIS_ITEM_AVAILABILITY.AVAILABLE;
  }
  return BOPIS_ITEM_AVAILABILITY.LIMITED;
}

function* getFavStoreDetails(stores, apiPayload) {
  // call favourite store api if the user's cart have not any store or
  // the selected cart store is not favorite
  const favoriteStore = {
    ...stores.find((store) => store.basicInfo.isDefault),
  };
  const { defaultStore: preferredStore, skuId, quantity, variantId, variantNo } = apiPayload;
  const defaultStore =
    JSON.parse(getLocalStorage('defaultStore')) || Object.assign({}, preferredStore);

  if (Object.keys(favoriteStore).length) {
    yield put(setDefaultStore(favoriteStore));
  } else if (defaultStore && defaultStore.basicInfo) {
    try {
      const itemInfo = [
        {
          storeId: defaultStore?.basicInfo?.id,
          variantNo,
          itemPartNumber: variantId,
        },
      ];
      const isStoreInventoryApiEnabled = yield select(getIsStoreInventoryApi);
      const state = yield select();
      const isBossMultipleStoreEnabled =
        state?.session?.siteDetails?.IS_BOSS_MULTIPLE_STORES_ENABLED;
      if (!isBossMultipleStoreEnabled) {
        const inventoryArray = yield call(
          getBopisInventoryDetails,
          itemInfo,
          [],
          isStoreInventoryApiEnabled
        );
        const inventory = inventoryArray[0];
        defaultStore.productAvailability = {
          quantity: inventory.quantity,
          skuId,
          status: getItemBopisAvailability(inventory, quantity),
        };
      }
    } catch (err) {
      logger.error({
        error: err,
        extraData: {
          component: 'PickUpStoreModalSaga - getFavStoreDetails',
          payload: apiPayload,
        },
      });
      defaultStore.productAvailability = {
        quantity: 0,
        skuId,
        status: BOPIS_ITEM_AVAILABILITY.UNAVAILABLE,
      };
    }
    if (!defaultStore.basicInfo.isDefault) {
      // setting store as user's geo default store in state not fav store
      // TODO - To validate this once HOME Pod has worked on it
      yield put(getSetGeoDefaultStoreActn(defaultStore));
    } else {
      yield put(setDefaultStore(defaultStore));
    }
  }
}

function* getUserCartStoresExt(payload) {
  const { isFromChangeStore, isSearchOnlyInCartStores, isCart, apiPayload, stores } = payload;
  if (!isSearchOnlyInCartStores && !isCart) {
    const { variantId = '' } = apiPayload;
    if (variantId) {
      yield call(getFavStoreDetails, stores, apiPayload);
    }
  }
  yield put(setIsGetUserStoresLoaded(true));
  if (isFromChangeStore) {
    yield put(setLoaderState(false));
  }
}
// eslint-disable-next-line sonarjs/cognitive-complexity
export function* getUserCartStores(action) {
  const { payload } = action;

  try {
    const { alwaysSearchForBOSS, apiPayload = {} } = payload;
    const { cartItemsCount, isFromChangeStore, isCart } = apiPayload;
    yield put(setBopisStores({ stores: [] }));
    yield put(setUserCartStores({ stores: null }));
    const isFromQV = yield select(getModalState);
    const isPDP = yield select(getIsPDP);
    const isBossMultipleStoreEnabled = yield select(getBossMultipleStoreEnabled);
    const isBopisMultipleStoreEnabled = yield select(getBopisMultipleStoreEnabled);
    if (!isPDP && !isFromQV && (isBopisMultipleStoreEnabled || isBossMultipleStoreEnabled)) {
      yield put(setStoreSearchError(''));
    }

    yield put(setIsGetUserStoresLoaded(false));
    let stores = [];
    if (cartItemsCount > 0) {
      stores = yield call(getCartStoresPlusInventorygraph, apiPayload);
    }
    const isSearchOnlyInCartStores = stores.length === maxAllowedStoresInCart;
    yield put(setUserCartStores({ stores }));
    const isValidZipCode = apiPayload && apiPayload.locationPromise;
    if (isValidZipCode && (!isSearchOnlyInCartStores || alwaysSearchForBOSS)) {
      yield call(getPickupStores, { payload: { ...apiPayload, isCallForCartStores: false } });
    }
    yield call(getUserCartStoresExt, {
      isFromChangeStore,
      isSearchOnlyInCartStores,
      isCart,
      apiPayload,
      stores,
    });
  } catch (err) {
    yield put(setLoaderState(false));
    logger.error({
      error: err,
      extraData: {
        component: 'PickUpStoreModalSaga - getUserCartStores',
        payloadRecieved: payload,
      },
    });
  }
  yield put(setIsGetUserStoresLoaded(true));
}

const checkIfMultiPack = (payload) => {
  return payload && payload.isMultiPack ? payload.isMultiPack : null;
};

function* fetchProductData({ payload }) {
  const { setInitialTCPStyleQty, otherBrand, brand, newFitsEnabled } = payload;
  try {
    const state = yield select();
    const xappURLConfig = yield call(getUnbxdXappConfigs);
    const payloadArray = Array.isArray(payload) ? payload : [payload];
    const { orderInfo } = payloadArray[0];
    let itemBrand;
    if (orderInfo) {
      ({ itemBrand } = orderInfo);
    }
    const isPdpServiceEnabled = yield select(getIsPdpServiceEnabled);
    const enablePDPServiceABTest = yield select(getABTestPdpService);
    const fetchDetailArray = payloadArray.map((product) => {
      const { colorProductId, generalProductId } = product;
      return call(
        getProductInfoById,
        xappURLConfig,
        colorProductId,
        state,
        itemBrand || brand,
        undefined,
        undefined,
        undefined,
        false,
        undefined,
        generalProductId,
        checkIfMultiPack(payload),
        isPdpServiceEnabled,
        enablePDPServiceABTest,
        null,
        otherBrand,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        newFitsEnabled
      );
    });
    const productDetailArray = yield all(fetchDetailArray);
    const product = productDetailArray && productDetailArray[0] && productDetailArray[0].product;
    yield put(
      setPickupModalProduct({
        product,
        setInitialTCPStyleQty,
      })
    );
    const { multiPackUSStore, tcpMultiPackReferenceUSStore } = product || {};
    if (parseBoolean(multiPackUSStore)) {
      let finalPartId = '';
      const partId = tcpMultiPackReferenceUSStore?.join(',').split(',');
      const updatedPartId = new Set(partId);
      const findUpdatedPartId = [...updatedPartId];
      for (let k = 0; k < findUpdatedPartId?.length; k += 1) {
        finalPartId += `${fetchProductId(findUpdatedPartId[k])},`;
      }
      const newMultiPackCount = findUpdatedPartId?.[0]?.split(',');
      const multiPackCount = newMultiPackCount && getMultipackCount(newMultiPackCount);

      const newfetchDetailArray = yield call(
        getProductInfoById,
        xappURLConfig,
        finalPartId,
        state,
        itemBrand,
        undefined,
        undefined,
        undefined,
        true,
        partId,
        undefined,
        undefined,
        isPdpServiceEnabled,
        enablePDPServiceABTest,
        null,
        otherBrand
      );
      const multiPackData = newfetchDetailArray
        ? {
            newPartNumber: getMultipackProduct(newfetchDetailArray),
            multiPackCount,
            getMultiPackAllColor: product.getMultiPackAllColor,
            getNewMultiPackAllColor:
              newfetchDetailArray && newfetchDetailArray.product.getMultiPackAllColor,
            partIdDetail: newfetchDetailArray && newfetchDetailArray.product.partIdDetails,
          }
        : null;
      yield put(setMultiPackDetails({ multiPackData }));
    } else {
      yield put(setMultiPackDetails({ multiPackData: null }));
    }
  } catch (error) {
    logger.error({
      error,
      extraData: {
        component: 'Bopis modal',
        payloadRecieved: payload,
      },
    });
  }
}

function* PickUpStoreSaga() {
  yield takeLatest(PICKUP_MODAL_ACTIONS_CONSTANTS.SET_PICKUP_MODAL, fetchProductData);
  yield takeLeading(PICKUP_MODAL_ACTIONS_CONSTANTS.GET_BOPIS_STORES, getPickupStores);
  yield takeLeading(PICKUP_MODAL_ACTIONS_CONSTANTS.GET_USER_CART_STORES, getUserCartStores);
}

export default PickUpStoreSaga;
